import { userTypesList, roles as rolesList } from 'constants/userTypes'

export const roles = rolesList.map(({ name: label, value }) => ({ label, value }))

export const rolesHash = roles.reduce((hash, role) => {
  hash[role.value] = role
  return hash
}, {})

export const userTypes = userTypesList.map(type => ({
  label: type.name,
  value: type.value,
  type: type.type,
}))

export const userTypesHash = userTypes.reduce((hash, type) => {
  hash[type.value] = type
  return hash
}, {})

export const userTypesGrouped = userTypes.reduce((groups, type) => {
  const group = groups[type.type] || []
  group.push(type)
  groups[type.type] = group
  return groups
}, {})
